module.exports = __webpack_public_path__ + "static/media/tab_lock_select.18225513.svg";